import React from 'react';
import { COLORS } from '../theme'; // 階層が変わるので ../ になります

const AdBanner = ({ config }) => {
  if (!config || !config.enabled) return null;
  return (
    <div style={{
        position:'fixed', bottom:'90px', left:0, width:'100%', zIndex:999, 
        background:'rgba(255,255,255,0.95)', borderTop:'1px solid #eee', 
        padding:'10px', boxSizing:'border-box', display:'flex', alignItems:'center', 
        gap:'10px', boxShadow:'0 -2px 5px rgba(0,0,0,0.05)', backdropFilter: 'blur(5px)'
    }}>
      {config.imageUrl && (
          <img src={config.imageUrl} style={{width:'50px', height:'50px', objectFit:'cover', borderRadius:'8px'}} alt="ad" />
      )}
      <div style={{flex:1}}>
        <div style={{fontSize:'10px', color:'#999', marginBottom:'2px'}}>PR</div>
        <div style={{fontSize:'12px', fontWeight:'bold', color:'#333'}}>{config.text}</div>
      </div>
      <a href={config.linkUrl} target="_blank" rel="noopener noreferrer" className="btn btn-sm" style={{background:COLORS.secondary, color:'#000', borderRadius:'20px'}}>
          詳細
      </a>
    </div>
  );
};

export default AdBanner;